import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPhone,
  faEnvelope,
  faLocationDot,
  faArrowRight,
} from '@fortawesome/free-solid-svg-icons';
import { faFacebookF } from '@fortawesome/free-brands-svg-icons';
import Header from '../components/Header';
import Kontaktformular from '../components/Kontaktformular';
import EmailAndPhoneButton from '../components/EmailAndPhoneButton';
import SEOHead from '../components/SEOHead';
import heroImage from '../images/Kontakt.jpg';
import './styles/Kontakt.css';

const kanaler = [
  {
    icon: faPhone,
    titel: 'Ring til os',
    vaerdi: '22 78 04 76',
    tekst: 'Den hurtigste vej til en snak om din opgave.',
    href: 'tel:+4522780476',
  },
  {
    icon: faEnvelope,
    titel: 'Skriv en mail',
    vaerdi: 'jbc@jbcentreprenoeren.dk',
    tekst: 'Vedhæft gerne billeder eller tegninger af opgaven.',
    href: 'mailto:jbc@jbcentreprenoeren.dk',
  },
  {
    icon: faLocationDot,
    titel: 'Find os',
    vaerdi: 'Naurvej 6, Undløse, 4340 Tølløse',
    tekst: 'Vi kører ud til opgaver på hele Sjælland.',
    href: 'https://www.google.com/maps/search/?api=1&query=Naurvej+6,+4340+T%C3%B8ll%C3%B8se',
    ekstern: true,
  },
];

const trin = [
  {
    titel: 'Du skriver eller ringer',
    tekst: 'Fortæl kort, hvad opgaven går ud på, og hvor den skal laves.',
  },
  {
    titel: 'Vi vender tilbage',
    tekst: 'Vi kontakter dig hurtigst muligt og afklarer eventuelle spørgsmål.',
  },
  {
    titel: 'Du får et gratis tilbud',
    tekst: 'Et klart og uforpligtende tilbud – så du ved, hvad du siger ja til.',
  },
];

function Kontakt() {
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'ContactPage',
    name: 'Kontakt JBC Entreprenøren',
    url: 'https://jbcentreprenoeren.dk/kontakt',
    mainEntity: { '@id': 'https://jbcentreprenoeren.dk/#business' },
  };

  return (
    <div className="kontakt-side">
      <SEOHead
        title="Kontakt os – gratis tilbud | JBC Entreprenøren"
        description="Kontakt JBC Entreprenøren i Undløse ved Tølløse for et gratis og uforpligtende tilbud på anlægs- og entreprenørarbejde på hele Sjælland. Ring 22 78 04 76."
        url="/kontakt"
        structuredData={structuredData}
        image="https://jbcentreprenoeren.dk/images/og-kontakt.jpg"
        breadcrumbs={[{ name: 'Hjem', url: '/' }, { name: 'Kontakt', url: '/kontakt' }]}
      />
      <Header />
      <EmailAndPhoneButton />

      <section className="kt-hero">
        <div className="kt-hero-bg">
          <img src={heroImage} alt="" />
        </div>
        <div className="kt-hero-inner">
          <nav className="kt-breadcrumb" aria-label="Brødkrumme">
            <Link to="/">Hjem</Link>
            <span aria-hidden="true">/</span>
            <span aria-current="page">Kontakt</span>
          </nav>
          <h1>Lad os tage en snak om dit projekt</h1>
          <p>
            Ring, skriv eller udfyld formularen. Vi giver altid et gratis og uforpligtende tilbud.
          </p>
        </div>
      </section>

      <section className="kt-main" aria-label="Kontaktmuligheder">
        <div className="kt-main-inner">
          <div className="kt-kanaler">
            <span className="hero-eyebrow">Kontakt</span>
            <h2>Vælg den vej, der passer dig</h2>
            <ul className="kt-kanal-liste">
              {kanaler.map((k) => (
                <li key={k.titel}>
                  <a
                    href={k.href}
                    className="kt-kanal"
                    {...(k.ekstern ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
                  >
                    <span className="kt-kanal-ikon" aria-hidden="true">
                      <FontAwesomeIcon icon={k.icon} />
                    </span>
                    <span className="kt-kanal-tekst">
                      <small>{k.titel}</small>
                      <strong>{k.vaerdi}</strong>
                      <span>{k.tekst}</span>
                    </span>
                    <FontAwesomeIcon icon={faArrowRight} className="kt-kanal-pil" aria-hidden="true" />
                  </a>
                </li>
              ))}
            </ul>

            <div className="kt-firma">
              <dl>
                <div>
                  <dt>Firma</dt>
                  <dd>JBC Entreprenøren ApS</dd>
                </div>
                <div>
                  <dt>CVR</dt>
                  <dd>44384345</dd>
                </div>
              </dl>
              <a
                href="https://www.facebook.com/p/Jbc-Entrepern%C3%B8ren-100085100491591/"
                className="kt-facebook"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faFacebookF} aria-hidden="true" />
                Følg os på Facebook
              </a>
            </div>
          </div>

          <div className="kt-formular">
            <Kontaktformular titel="Send os en besked" />
          </div>
        </div>
      </section>

      <section className="kt-trin" aria-labelledby="kt-trin-titel">
        <div className="kt-trin-inner">
          <span className="hero-eyebrow">Hvad sker der nu?</span>
          <h2 id="kt-trin-titel">Fra henvendelse til tilbud</h2>
          <ol className="kt-trin-liste">
            {trin.map((t, i) => (
              <li key={t.titel}>
                <span className="kt-trin-nr" aria-hidden="true">{i + 1}</span>
                <h3>{t.titel}</h3>
                <p>{t.tekst}</p>
              </li>
            ))}
          </ol>
        </div>
      </section>
    </div>
  );
}

export default Kontakt;
